import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { MOCKUP_IMAGE } from '../../data/content';
export function FinalCTA() {
  return <section className="w-full bg-navy px-4 pb-32 pt-14 sm:pt-20" data-id="element-121" data-mp="3mu1r42g0wwaq">
      <div className="mx-auto max-w-2xl text-center" data-id="element-122" data-mp="3mrnye08tfw6c">
        <p className="text-[11px] font-bold uppercase tracking-[0.25em] text-brandred-light" data-id="element-123" data-mp="3rs390k1pqpkm">
          🚨 Último paso
        </p>
        <h2 className="mt-3 font-display text-[26px] leading-tight font-black tracking-tight text-white sm:text-4xl" data-id="element-124" data-mp="3dritbwr3h9vc">
          Toma decisiones correctas en{' '}
          <span className="italic text-brandred-light" data-id="element-125" data-mp="33vphygp43mf5">menos de 60 segundos</span>
        </h2>
        <p className="mx-auto mt-4 max-w-lg text-[15px] leading-relaxed text-white/70" data-id="element-126" data-mp="38th8b6a3z0h8">
          Puedes seguir enfrentando cada caso con incertidumbre… o contar con un sistema que te guíe
          en cada decisión. Incluso en escenarios donde equivocarse no es una opción.
        </p>

        <img src={MOCKUP_IMAGE} alt="Sistema completo Ruta Anticoagulación con sus 6 tomos y 5 bonos" className="mx-auto mt-8 w-full max-w-md" data-id="element-127" data-mp="q8di91r8v4uc" />

        <div className="mt-4 flex justify-center" data-id="element-128" data-mp="z0xk0b2u1pje">
          <CTAButton sub="Acceso inmediato · Pago único · Garantía total" data-id="element-129" data-mp="yznjzgcf67a4" />
        </div>

        <div className="mt-10 flex items-start gap-3 rounded-2xl border border-white/15 bg-white/[0.06] p-4 text-left" data-id="element-130" data-mp="v0ereet48fg5">
          <AlertTriangleIcon className="mt-0.5 h-5 w-5 shrink-0 text-amber-400" strokeWidth={2.5} aria-hidden data-id="element-131" data-mp="7aavyuq2zm08" />
          <p className="text-[13.5px] leading-snug text-white/75" data-id="element-132" data-mp="gaz3d6kyyo45">
            <strong className="font-bold text-white" data-id="element-133" data-mp="g834ng1arven">Nota final:</strong> cada día que postergas una
            mejor forma de decidir es un día más enfrentando riesgos innecesarios. Y en
            anticoagulación… cada decisión cuenta.
          </p>
        </div>

        <footer className="mt-10 border-t border-white/10 pt-6" data-id="element-134" data-mp="1mpzyja26729o">
          <p className="font-display text-base font-bold text-white" data-id="element-135" data-mp="kdn215q3e8lt">
            Ruta Anticoagulación™ · Dra. Karito
          </p>
          <p className="mt-2 text-[11px] leading-relaxed text-white/40" data-id="element-136" data-mp="pan475jtmr7n">
            Material educativo dirigido a profesionales de la salud. No sustituye el criterio
            clínico ni la evaluación individual de cada paciente.
          </p>
          <p className="mt-3 text-[11px] text-white/30" data-id="element-137" data-mp="1mvtg6dxim8h">
            © {new Date().getFullYear()} Ruta Anticoagulación™. Todos los derechos reservados.
          </p>
        </footer>
      </div>
    </section>;
}